import { render } from "./TemplateEditor.vue?vue&type=template&id=e2a32054&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&lang=js"

import "./TemplateEditor.vue?vue&type=style&index=0&id=e2a32054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a32054"]])

export default __exports__